import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  text-align: center;
  max-width: 100%;
  overflow: hidden;
  height: 400px;
  margin-bottom:50px;
  background-image: url(${(props) => props.imgUrl});
  background-repeat: no-repeat;
  // background-size:cover;
  background-position: center;

  @media (max-width: 768px) {
    background-image: url(${({ mobileImgUrl }) => mobileImgUrl});
    background-position: left;
  }

  // img {
  //   width: 1650px;
  //   margin:0 -100%;
  //   vertical-align:middle;
  // }
`;

function Image({ input }) {
  return (
    <Container imgUrl={input.primary.main_image.url}></Container>
  );
}

export { Image };

/* <img src={input.primary.main_image.url} /> */
